import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { Form } from "react-final-form";
import * as S from "../../constants/StringConstants";
import { IFinalTableContextValue } from "../FinalTable/FinalTable";
import FinalTableSpy from "../FinalTable/FinalTableSpy";
import TextField from "../Form/TextFieldV2/TextFieldV2";
import { ITypeaheadOption, transformOptions } from "../Form/TypeaheadFieldV2/TypeaheadFieldV2";

import "./TextFilter.scss";

interface Field {
  type: "text" | "typeahead";
  name: string;
  label: string;
  options?: ITypeaheadOption[];
  paramHandler?: (value: string) => any;
}

export interface ITextFilterProps {
  fields: Field[];
  inputProps?: any;
}

const TextFilter: React.FC<ITextFilterProps> = ({ fields, inputProps }) => {
  const handleChange = (
    props: IFinalTableContextValue<{}>,
    fieldName: string,
    form: any,
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    form.change(fieldName, value);

    let query;

    query = {
      ...props.query,
      [fieldName]: value,
    };

    props.update({ page: 1, query });
  };

  const handleChangeTypeAhead = (
    props: IFinalTableContextValue<{}>,
    fieldName: string,
    form: any,
    value,
    paramHandler,
  ) => {
    // const value = e.target.value;
    form.change(fieldName, value);

    let query;

    if (paramHandler) {
      query = {
        ...props.query,
        ...paramHandler(value),
      };
    } else {
      query = {
        ...props.query,
        [fieldName]: value,
      };
    }

    props.update({ page: 1, query });
  };

  return (
    <FinalTableSpy>
      {props => (
        <Form
          onSubmit={vals => {
            // update when field is deleted
            const cleanedQuery = Object.entries(vals).reduce(
              (acc, [key, val]) => {
                if (val?.toString().trim() !== "") {
                  acc[key] = val;
                }
                return acc;
              },
              {} as Record<string, any>,
            );

            props.update({ page: 1, query: cleanedQuery });
          }}
          render={({ handleSubmit, form }) => (
            <>
              {fields.map(({ type, name, label, paramHandler, options = [] }) => (
                <React.Fragment key={name}>
                  {type == "text" && (
                    <TextField
                      name={name}
                      placeholder={label}
                      bare={true}
                      inputProps={{
                        ...inputProps,
                        onKeyPress: e => {
                          if (e.key === "Enter") {
                            handleSubmit();
                          }
                        },
                      }}
                      onChange={e => handleChange(props, name, form, e)}
                    />
                  )}
                  {type == "typeahead" && (
                    <div className="textfilter-typeahead">
                      <Typeahead
                        key={name}
                        name={name}
                        placeholder={label}
                        options={transformOptions(options)}
                        selected={""}
                        multiple={false}
                        onChange={selectedItems => {
                          handleChangeTypeAhead(props, name, form, selectedItems[0]?.value ?? null, paramHandler);
                        }}
                      />
                    </div>
                  )}
                </React.Fragment>
              ))}
              <button className="button-v2 gray small" onClick={handleSubmit}>
                {S.APP_FILTERS_SEARCH}
              </button>
            </>
          )}
        />
      )}
    </FinalTableSpy>
  );
};

export default TextFilter;
